import React from "react";
import { useNavigate } from "react-router-dom";
import "./ReservationCard.css";

const DAYS = ["Dim.", "Lun.", "Mar.", "Mer.", "Jeu.", "Ven.", "Sam."];
const MONTHS = [
  "jan.", "fév.", "mar.", "avr.", "mai", "juin",
  "juil.", "août", "sep.", "oct.", "nov.", "déc.",
];

function formatDate(isoString) {
  const d = new Date(isoString.split("T")[0] + "T00:00:00");
  return `${DAYS[d.getDay()]} ${d.getDate()} ${MONTHS[d.getMonth()]} ${d.getFullYear()}`;
}

function formatTime(isoString) {
  return isoString.split("T")[1].substring(0, 5);
}

const ReservationCard = ({ reservation, past = false }) => {
  const navigate  = useNavigate();
  const confirmed = reservation.reservationConfirmed;

  let accent = "card-accent--past";
  if (!past) {
    accent = confirmed ? "card-accent--confirmed" : "card-accent--pending";
  }

  const handleTap = () => {
    navigate(`/my-reservation/${reservation._id}`);
  };

  return (
    <div
      className={`res-card ${past ? "res-card--past" : ""}`}
      onClick={handleTap}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => e.key === "Enter" && handleTap()}
      style={{ cursor: "pointer", WebkitTapHighlightColor: "transparent" }}
    >
      <div className={`res-card-accent ${accent}`} />
      <div className="res-card-body">
        <div className="res-card-top">
          <span className="res-card-date">
            {formatDate(reservation.start)}
          </span>
          <span className="res-card-time">
            {formatTime(reservation.start)} – {formatTime(reservation.end)}
          </span>
        </div>
        <div className="res-card-bottom">
          <span className="res-card-terrain">{reservation.terrain.name}</span>
          <div className="res-card-right">
            <div className="res-card-dots">
              {[0, 1, 2, 3].map((i) => (
                <span
                  key={i}
                  className={`res-card-dot ${i < 4 - reservation.availablePlaces ? "res-card-dot--taken" : "res-card-dot--free"}`}
                />
              ))}
            </div>
            <span className={`res-card-badge ${confirmed ? "res-card-badge--ok" : "res-card-badge--pending"}`}>
              {confirmed ? "Confirmée" : "En attente"}
            </span>
          </div>
        </div>
      </div>
      {/* Chevron hint on upcoming */}
      {!past && (
        <div style={{
          display: "flex", alignItems: "center", paddingRight: 12,
          color: "#cbd5e1", fontSize: 20, flexShrink: 0,
        }}>
          ›
        </div>
      )}
    </div>
  );
};

export default ReservationCard;
